module.exports = __webpack_public_path__ + "img/n26-dark.b39dc651.png";